var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"cx-option"},_vm._l((Object.keys(_vm.data)),function(section,index){return _c('a',{key:section,staticClass:"cx-option__item",class:{'-active': index == _vm.active},on:{"click":function($event){return _vm.$emit('sectionChanged', index)}}},[_vm._v(_vm._s(section))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }